export default "__VITE_PUBLIC_ASSET__ed10a0e6__"